export const API_URL = (import.meta.env.VITE_API_URL || 'http://127.0.0.1:8787') + '/api';

export const defaultOptions = {
    mode: 'cors' as RequestMode,
    headers: {
        'Content-Type': 'application/json',
    },
    credentials: 'include' as RequestCredentials
};

export const getAuthOptions = () => ({
    ...defaultOptions,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
    }
});

export const authOptions = getAuthOptions();
